import { Section, H2, P, Bullets, Table, Callout } from "./Primitives";

const Timeline = () => (
  <div className="timeline avoid-break mb-12" data-testid="roadmap-timeline">
    {[
      { f: "Fase 1", t: "Mesi 1–6 · Gen–Giu 2027", h: "Consolidamento iper-locale e B2B", d: "Raggio 3–5 km e provincia di Salerno", b: "€ 14.400" },
      { f: "Fase 2", t: "Mesi 6–12 · Lug–Dic 2027", h: "Dominio regionale", d: "Tutta la Campania: Luxury, spedizioni, notorietà", b: "€ 13.500" },
      { f: "Fase 3", t: "Anno 2+ · dal 2028", h: "Lead generation franchising", d: "Italia: imprenditori e aspiranti affiliati", b: "€ 26.400 / anno" },
    ].map((p, i) => (
      <div key={p.f} className="timeline-step" data-testid={`timeline-phase-${i + 1}`}>
        <div className="timeline-dot" />
        <div className="kicker">{p.f} · {p.t}</div>
        <div className="font-display text-xl text-navy mt-1 mb-2">{p.h}</div>
        <div className="text-sm text-[var(--ink-soft)] mb-3">{p.d}</div>
        <div className="text-sm"><span className="text-[var(--ink-soft)]">Budget media (medio): </span><strong>{p.b}</strong></div>
      </div>
    ))}
  </div>
);

const MarketData = () => (
  <>
  <H2>Simulazione di mercato: domanda di ricerca e costi di riferimento</H2>
  <Table
    testId="table-keywords"
    head={["Ricerca / pubblico", "Volume medio mensile (Italia)", "Picco stagionale", "Costo per clic stimato"]}
    rows={[
      ["“cesti natalizi aziendali”", "9.900 – 14.800", "Ott–Dic (×4–6)", "€ 0,90 – 2,00"],
      ["“regali aziendali natale”", "6.600 – 8.100", "Nov–Dic", "€ 0,80 – 1,80"],
      ["“dolci artigianali online”", "1.000 – 1.600", "Dic, Pasqua", "€ 0,50 – 1,20"],
      ["“babà / pastiera spedizione”", "1.300 – 2.400", "Pasqua, Natale", "€ 0,40 – 0,90"],
      ["“pasticceria franchising”", "500 – 900", "Gen–Mar, Set", "€ 1,50 – 3,50"],
      ["“aprire una pasticceria”", "1.000 – 1.600", "Tutto l'anno", "€ 1,20 – 2,80"],
      ["LinkedIn · CEO, HR, Office Manager (Campania)", "≈ 18.000 – 25.000 profili", "Set–Nov", "€ 4,00 – 8,00"],
      ["Meta · residenti 3–5 km dai 7 punti vendita", "≈ 250.000 – 350.000 persone", "Tutto l'anno", "€ 0,25 – 0,60"],
    ]}
    foot="Volumi e costi per clic sono stime di mercato (fonti nella nota metodologica), non preventivi delle piattaforme."
  />

  </>
);

const PhaseOne = () => (
  <>
  <H2>Fase 1 · Mesi 1–6 — Consolidamento iper-locale e B2B</H2>
  <P>
    <strong>Obiettivo B2C</strong>: trasformare i clienti abituali dei 7 punti vendita in utenti dell'App, con campagne Meta (Facebook e Instagram) geolocalizzate nel raggio di 3–5 km da ogni sede.
    <br />
    <strong>Obiettivo B2B</strong>: raggiungere CEO, responsabili HR e office manager nella provincia di Salerno, dove si stimano circa <strong>6.800 aziende con almeno 10 dipendenti</strong>, per la campagna strenne natalizie.
    La campagna parte a febbraio 2027: le prime commesse arrivano con la Pasqua aziendale e gli eventi di primavera.
    Nello stesso periodo si costruisce il portafoglio di aziende che prenoteranno in anticipo le strenne di Natale 2027, con listino bloccato e sconto early booking.
  </P>
  <Bullets
    items={[
      <><strong>Meta Ads, App</strong>: € 900/mese con un costo per installazione atteso di € 1,50–3,00 (medio € 2,25) e circa <strong>2.400 nuovi utenti</strong> in sei mesi.</>,
      <><strong>Google Search, B2B</strong>: € 5.000 nel semestre. A € 1,40 per clic e con il 4% dei visitatori che richiede un preventivo, si stimano circa 140 contatti (≈ € 35 l'uno).</>,
      <><strong>LinkedIn, B2B</strong>: € 4.000 nel semestre. A € 6 per clic e con il 12% di compilazione del modulo, si stimano circa 80 contatti (≈ € 50 l'uno).</>,
      <><strong>Calendario B2B</strong>: € 500 a gennaio, € 2.000 a febbraio, € 2.500 a marzo (Pasqua), € 1.500 ad aprile, € 1.250 a maggio e a giugno (media € 1.500/mese).</>,
      <>Riferimento commerciale: un cesto aziendale vale <strong>€ 30–80 per dipendente</strong>. Un ordine medio stimato di 30 dipendenti a € 50 corrisponde a <strong>€ 1.500</strong>.</>,
    ]}
  />
  <Table
    testId="table-phase1"
    head={["Fase 1 (6 mesi)", "Prudente", "Medio", "Aggressivo"]}
    rows={[
      ["Budget Meta (App)", "€ 3.600", "€ 5.400", "€ 8.400"],
      ["Costo per installazione", "€ 3,00", "€ 2,25", "€ 2,00"],
      ["Nuovi utenti App", "1.200", "2.400", "4.200"],
      ["Budget Google + LinkedIn (B2B)", "€ 6.000", "€ 9.000", "€ 13.200"],
      ["Costo per contatto B2B", "€ 50", "€ 40", "€ 30"],
      ["Contatti B2B qualificati", "120", "225", "440"],
      ["Ordini (15% / 15% / 12%)", "18", "34", "53"],
      ["Vendite da campagna", "€ 27.000", "€ 51.000", "€ 79.500"],
      ["+ Aziende già clienti portate sul portale", "€ 13.000", "€ 9.000", "€ 10.500"],
      { strong: true, cells: ["Vendite B2B anno 1", "€ 40.000", "€ 60.000", "€ 90.000"] },
      { strong: true, cells: ["Budget media Fase 1 totale", "€ 9.600", "€ 14.400", "€ 21.600"] },
    ]}
  />
  <Callout title="Lettura del direttore commerciale">
    Nello scenario medio ogni euro investito in pubblicità B2B genera circa <strong>€ 6,70 di vendite</strong> e <strong>€ 2,50 di margine</strong>, con un margine lordo della linea strenne del 38%.
    La campagna B2B si ripaga quindi entro il suo primo anno, tra Pasqua e Natale 2027.
  </Callout>

  </>
);

const PhaseTwo = () => (
  <>
  <H2>Fase 2 · Mesi 6–12 — Dominio regionale</H2>
  <P>
    Si estendono le campagne a <strong>tutta la Campania</strong>, circa 5,6 milioni di abitanti, per tre obiettivi: vendere la Linea Luxury, sviluppare le spedizioni di dolci artigianali e consolidare la notorietà del marchio in vista del franchising.
  </P>
  <Bullets
    items={[
      <><strong>Notorietà (Meta/Instagram)</strong>: € 1.000/mese con un costo per mille visualizzazioni di € 3–5 e circa 250.000 visualizzazioni al mese.</>,
      <><strong>Vendite online e spedizioni (Google Search e Shopping)</strong>: € 700/mese. Le ricerche di riferimento sono “babà online” e “dolci artigianali online”, con un costo per clic di € 0,50–1,20.</>,
      <><strong>Richiamo di chi ha già visitato (Meta)</strong>: € 200/mese verso chi ha visto la Linea Luxury o il sito.</>,
      <><strong>Richiamo B2B per il Natale 2027 (LinkedIn)</strong>: € 350/mese tra settembre e novembre verso i circa 225 contatti aziendali raccolti in Fase 1, quando le aziende decidono le strenne.</>,
      <>KPI attesi: <strong>costo per ordine online € 12–20</strong>, ordine medio € 45 e circa 70 ordini spediti al mese nello scenario medio.</>,
    ]}
  />
  <Table
    testId="table-phase2"
    head={["Fase 2 (6 mesi)", "Prudente", "Medio", "Aggressivo"]}
    rows={[
      ["Budget mensile", "€ 1.600", "€ 2.250", "€ 3.200"],
      ["Costo per ordine online", "€ 20", "€ 15", "€ 12"],
      ["Ordini spediti / mese", "40", "70", "125"],
      ["Ricavi online / mese", "€ 1.800", "€ 3.150", "€ 5.600"],
      ["Persone raggiunte in Campania", "≈ 400.000", "≈ 600.000", "≈ 900.000"],
      { strong: true, cells: ["Budget media Fase 2 totale", "€ 9.600", "€ 13.500", "€ 19.200"] },
    ]}
  />

  </>
);

const PhaseThree = () => (
  <>
  <H2>Fase 3 · Anno 2+ — Lead generation franchising</H2>
  <P>
    Con processi standardizzati, numeri certificati dal gestionale e un marchio riconosciuto, Bella Napoli è pronta ad aprirsi ai partner.
    La comunicazione diventa <strong>nazionale</strong> e si rivolge <strong>solo a imprenditori</strong> interessati ad aprire un punto vendita affiliato, tramite Google Search e LinkedIn.
  </P>
  <Bullets
    items={[
      <><strong>Google Search</strong> (“pasticceria franchising”, “aprire una pasticceria”): € 1.200/mese, con un costo per clic di € 1,50–3,50.</>,
      <><strong>LinkedIn</strong> verso imprenditori, manager in uscita e investitori del settore food: € 1.000/mese, con un costo per clic di € 5–9.</>,
      <>Costo per contatto qualificato: <strong>€ 50–120</strong>. Circa il 15% dei contatti dispone del capitale necessario (€ 80.000–120.000).</>,
      <>Riferimento di mercato: <strong>fee d'ingresso di € 8.000–15.000</strong>, più royalty ricorrenti sul fatturato dell'affiliato.</>,
    ]}
  />
  <Table
    testId="table-phase3"
    head={["Fase 3 (per anno)", "Prudente", "Medio", "Aggressivo"]}
    rows={[
      ["Budget mensile", "€ 1.500", "€ 2.200", "€ 3.500"],
      ["Costo per contatto", "€ 120", "€ 80", "€ 60"],
      ["Contatti / anno", "150", "330", "700"],
      ["Candidati con capitale adeguato", "22", "50", "105"],
      ["Nuove aperture / anno", "1", "3", "5"],
      ["Costo pubblicitario per affiliato", "€ 18.000", "€ 8.800", "€ 8.400"],
      { strong: true, cells: ["Budget media Fase 3 annuo", "€ 18.000", "€ 26.400", "€ 42.000"] },
    ]}
    foot="Nello scenario medio la sola fee d'ingresso, pari a € 12.000, copre il costo pubblicitario per affiliato. Le royalty costituiscono margine netto ricorrente."
  />

  </>
);

const MethodNote = () => (
  <>
  <div className="method avoid-break" data-testid="methodology-note">
    <div className="kicker mb-2">Nota metodologica</div>
    <p>
      Le stime derivano da benchmark pubblici del mercato italiano 2025–2026: Google Ads Keyword Planner per i volumi indicativi, report di settore sui costi per clic e per contatto (WordStream, LocaliQ, Databox) e LinkedIn Campaign Manager per le dimensioni dei pubblici.
      Il numero di imprese per classe di addetti proviene dall'archivio ISTAT ASIA e il riferimento sulle fee d'ingresso dai rapporti Assofranchising.
      I dati di Bella Napoli sono ipotesi prudenti in assenza di dati consuntivi: scontrino medio € 9,50, circa 180 scontrini al giorno per sede, fatturato di gruppo di circa € 3,5 milioni.
      <strong> Si tratta di stime, non di preventivi.</strong> Saranno ricalibrate sui dati reali dopo i primi 60 giorni di attività.
    </p>
  </div>
  </>
);

export const Roadmap = () => (
  <Section id="roadmap" num="05" kicker="RoadMap di Espansione e Budget Media" title="Crescere per cerchi concentrici">
    <P>
      L'espansione procede per <strong>cerchi concentrici</strong>: prima si rafforza il bacino che già conosce Bella Napoli, poi si conquista la regione e infine si apre il marchio agli affiliati.
      Ogni budget è stato ricavato da una simulazione sulle metriche medie del mercato italiano: costo per clic, volumi di ricerca e costo per contatto.
      Per ogni fase sono indicati tre scenari. Il piano economico adotta lo scenario <strong>medio</strong>.
    </P>
    <Timeline />

    <MarketData />
    <PhaseOne />
    <PhaseTwo />
    <PhaseThree />
    <MethodNote />
  </Section>
);
